/* eslint-disable react-hooks/exhaustive-deps */
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";

import {
	EmployerCategoriesForEntertainmentAllowance,
	MaximumLimits,
	RegimeTypes
} from "../../../../config/filingConstants";
import { IAddIncomeForm } from "../../../../config/interfaces";
import { useAppDispatch, useAppSelector } from "../../../../redux/Store";
import { showHintModal } from "../../../../redux/slice/HintModalSlice";
import { ITRFilingSelector } from "../../../../redux/slice/ITRFilingSlice";
import FASvgIcon from "../../../FASvgIcon";
import PriceDisplay from "../../../PriceDisplay";
import { FormField, NumericInputField } from "../../../fields";

const SalaryDeductionsAndReliefForm: React.FC = () => {
	const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext<IAddIncomeForm>();

	const dispatch = useAppDispatch();
	const { currentFilingData } = useAppSelector(ITRFilingSelector);

	const RegimeType = currentFilingData?.efilingData?.FilingReturnInfo?.RegimeType;

	useEffect(() => {
		const ProfTax16iii =
			RegimeType === RegimeTypes.NEW_TAX_REGIME
				? 0
				: Math.min(
						Number(values?.ProfessionalTaxUnderSection16iii || "0"),
						MaximumLimits.ProfTax16iii
				  );

		const sum =
			Number(values?.StandardDeductions16ia || "0") +
			Number(values?.EntertainmentAllowance16ii || "0") +
			ProfTax16iii;
		setFieldValue("SalaryTotalDeductions", sum);
	}, [
		values.StandardDeductions16ia,
		values.EntertainmentAllowance16ii,
		values.ProfessionalTaxUnderSection16iii
	]);

	return (
		<>
			<section className="ms-2">
				<p className="leading-para">Deduction under section 16</p>

				<Card className="more-info-card shadow-none mb-5">
					<Card.Header>
						<Card.Title>Break up of deduction under section 16</Card.Title>
					</Card.Header>
					<Card.Body className="pb-0">
						<section>
							<FormField label="Standard Deduction - 16(ia)" sm={6}>
								<NumericInputField
									showLeftIcon={true}
									isDisabled={true}
									name="StandardDeductions16ia"
									value={values.StandardDeductions16ia || ""}
									onBlur={handleBlur("StandardDeductions16ia")}
									onChange={(_value) => setFieldValue("StandardDeductions16ia", _value)}
									isInvalid={
										Boolean(errors.StandardDeductions16ia) && touched.StandardDeductions16ia
									}
									errorMsg={errors.StandardDeductions16ia}
								/>
							</FormField>

							{EmployerCategoriesForEntertainmentAllowance.includes(values.EmployerCategory) ? (
								<FormField label="Entertainment Allowance - 16(ii)" sm={6}>
									<NumericInputField
										showLeftIcon={true}
										name="EntertainmentAllowance16ii"
										value={values.EntertainmentAllowance16ii || ""}
										onBlur={handleBlur("EntertainmentAllowance16ii")}
										onChange={(_value) => setFieldValue("EntertainmentAllowance16ii", _value)}
										isInvalid={
											Boolean(errors.EntertainmentAllowance16ii) &&
											touched.EntertainmentAllowance16ii
										}
										errorMsg={errors.EntertainmentAllowance16ii}
									/>
								</FormField>
							) : null}

							<FormField label="Professional Tax - 16(iii)" sm={6}>
								<NumericInputField
									showLeftIcon={true}
									name="ProfessionalTaxUnderSection16iii"
									value={
										RegimeType === RegimeTypes.NEW_TAX_REGIME
											? ""
											: values.ProfessionalTaxUnderSection16iii
									}
									onBlur={handleBlur("ProfessionalTaxUnderSection16iii")}
									onChange={(_value) => {
										if (RegimeType === RegimeTypes.NEW_TAX_REGIME) {
											setFieldValue("ProfessionalTaxUnderSection16iii", 0);
											return;
										}
										setFieldValue("ProfessionalTaxUnderSection16iii", _value);
									}}
									isInvalid={
										Boolean(errors.ProfessionalTaxUnderSection16iii) &&
										touched.ProfessionalTaxUnderSection16iii
									}
									errorMsg={errors.ProfessionalTaxUnderSection16iii}
									isDisabled={RegimeType === RegimeTypes.NEW_TAX_REGIME}
								/>
							</FormField>
						</section>
					</Card.Body>
					<Card.Footer>
						<p className="total-content">
							<span className="total-label">Total:</span>
							<span className="total-amount">
								<PriceDisplay price={Number(values?.SalaryTotalDeductions || "0")} />
							</span>
						</p>
					</Card.Footer>
				</Card>
			</section>

			<div className="os-title-wrap">
				<h5 className="fw-bold">
					V. Relief under section 89
					<span
						className="info-wrap"
						role="button"
						onClick={() => {
							dispatch(
								showHintModal({
									title: "Relief u/s 89",
									componentName: "Relief89Hint"
								})
							);
						}}
					>
						<FASvgIcon icon={faInfoCircle} />
					</span>
				</h5>
				<NumericInputField
					showLeftIcon={true}
					name="ReliefUnderSection89"
					value={values.ReliefUnderSection89}
					onBlur={handleBlur("ReliefUnderSection89")}
					onChange={(_value) => setFieldValue("ReliefUnderSection89", _value)}
					isInvalid={Boolean(errors.ReliefUnderSection89) && touched.ReliefUnderSection89}
					errorMsg={errors.ReliefUnderSection89}
				/>
			</div>
			<hr />

			<div className="os-title-wrap">
				<h5 className="fw-bold">VI. Income claimed for relief under section 89A</h5>
				<NumericInputField
					showLeftIcon={true}
					name="IncomeClaimedForReliefUnderSection89A"
					value={values.IncomeClaimedForReliefUnderSection89A}
					onBlur={handleBlur("IncomeClaimedForReliefUnderSection89A")}
					onChange={(_value) => setFieldValue("IncomeClaimedForReliefUnderSection89A", _value)}
					isInvalid={
						Boolean(errors.IncomeClaimedForReliefUnderSection89A) &&
						touched.IncomeClaimedForReliefUnderSection89A
					}
					errorMsg={errors.IncomeClaimedForReliefUnderSection89A}
				/>
			</div>
			<hr />
		</>
	);
};

export default SalaryDeductionsAndReliefForm;
